const CASTING_TYPES = Object.freeze({
    NONE: 'none',
    INTEGER: 'integer',
    PHONE_NUMBER: 'phonenumber',
});

export { CASTING_TYPES };

export default [
    {
        type: 'product',
        id: 1,
        title: window.i18n.__('Produits'),
        description: window.i18n.__(
            'Les produits font partie de votre catalogue et correspondent aux références que vous proposez à la vente au sein de votre entreprise.',
        ),
        comparisonCriteriaDescription: window.i18n.__(
            'Cette section vous permet de déterminer le critère sur lequel nous allons déterminer si un produit existe déjà dans vos données Sellsy.',
        ),
        icon: 'obj-slsy-product',
        object: 'product',
        optionsDictionary: 'importProductOptionsDictionary',
        displaySubTypeOrder: ['product'],
        dataBot: 'import-card-product',
        customFieldsRelated: [
            {
                category: 'item',
                customField: 'customFieldProduct',
                title: window.i18n.__('Champs personnalisés produit'),
                subtitle: window.i18n.__('Champs personnalisés'),
            },
        ],
        isNew: true,
        fields: [
            {
                key: 'id',
                type: 'number',
                label: window.i18n.__('Identifiant produit'),
                description: window.i18n.__(
                    'Récupéré depuis un export Sellsy (Utile uniquement en cas de mise à jour).',
                ),
                metadata: {
                    castingType: CASTING_TYPES.INTEGER,
                },
            },
            {
                key: 'reference',
                type: 'string',
                label: window.i18n.__('Référence'),
                description: window.i18n.__(
                    'Référence ou code du produit unique dans votre catalogue.',
                ),
            },
            {
                key: 'name',
                type: 'string',
                label: window.i18n.__('Nom commercial'),
                description: window.i18n.__('Nom du produit affiché sur les documents.'),
            },
            {
                key: 'description',
                type: 'string',
                label: window.i18n.__('Description'),
                description: window.i18n.__('Description affichée sur les documents.'),
            },
            {
                key: 'characteristic_weight',
                type: 'number',
                label: window.i18n.__('Poids'),
                description: window.i18n.__('Poids de produit.'),
            },
            {
                key: 'unit',
                type: 'string',
                label: window.i18n.__('Unité'),
                description: window.i18n.__('Unité de quantification du produit.'),
            },
            {
                key: 'standard_quantity',
                type: 'number',
                label: window.i18n.__('Quantité usuelle'),
                description: window.i18n.__('Quantité usuelle du produit.'),
            },
            {
                key: 'category',
                type: 'string',
                label: window.i18n.__('Catégorie'),
                description: window.i18n.__(
                    'Catégorie du produit. Visibles dans Catalogue -> Catégories.',
                ),
            },
            {
                key: 'smart_tags',
                type: 'string',
                label: window.i18n.__('Smart-tags'),
                description: window.i18n.__('Liste de smart-tags. À séparer par une virgule.'),
                metadata: {
                    castingType: CASTING_TYPES.NONE,
                },
            },
            {
                key: 'owner',
                type: 'string',
                label: window.i18n.__('Propriétaire'),
                description: window.i18n.__('Nom complet du propriétaire du produit importé.'),
            },
            {
                key: 'reference_price',
                type: 'number',
                label: window.i18n.__('Prix de référence HT'),
                description: window.i18n.__('Prix de référence hors taxe du produit.'),
            },
            {
                key: 'tax_rate',
                type: 'number',
                label: window.i18n.__('Taxe'),
                description: window.i18n.__('Taux de taxe associé au produit.'),
            },
            {
                key: 'purchase_price',
                type: 'number',
                label: window.i18n.__('Prix achat HT'),
                description: window.i18n.__("Prix d'achat hors taxe du produit."),
            },
            {
                key: 'accounting_code',
                type: 'string',
                label: window.i18n.__('Code comptable vente'),
                description: window.i18n.__('Code comptable de vente à associer au produit.'),
            },
            {
                key: 'accounting_purchase_code',
                type: 'string',
                label: window.i18n.__('Code comptable achat'),
                description: window.i18n.__("Code comptable d'achat à associer au produit."),
            },
            {
                key: 'barcodes',
                type: 'string',
                label: window.i18n.__('Code barre'),
                description: window.i18n.__(
                    'Valeur du code barre, plusieurs valeurs peuvent être générées.',
                ),
            },
            {
                key: 'is_archived',
                type: 'boolean',
                label: window.i18n.__('Archivé'),
                description: window.i18n.__('Archiver ou non le produit.'),
            },
        ],
    },
    {
        type: 'company',
        id: 2,
        title: window.i18n.__('Sociétés et contacts'),
        description: window.i18n.__(
            'Les sociétés correspondent à des entreprises clients, prospects ou fournisseurs auxquelles des contacts et adresses peuvent être liés.',
        ),
        comparisonCriteriaDescription: window.i18n.__(
            'Cette section vous permet de déterminer le critère sur lequel nous allons déterminer si une société existe déjà dans vos données Sellsy.',
        ),
        icon: 'obj-slsy-company',
        object: 'company',
        optionsDictionary: 'importCompanyOptionsDictionary',
        displaySubTypeOrder: ['company', 'address', 'contact'],
        dataBot: 'import-card-company',
        customFieldsRelated: [
            {
                category: 'client',
                customField: 'customFieldCompany',
                title: window.i18n.__('Champs personnalisés'),
                subtitle: window.i18n.__('Champs personnalisés'),
                subheading: window.i18n.__(' / Sociétés'),
            },
            {
                category: 'prospect',
                customField: 'customFieldCompany',
                title: window.i18n.__('Champs personnalisés'),
                subtitle: window.i18n.__('Champs personnalisés'),
                subheading: window.i18n.__(' / Sociétés'),
            },
            {
                category: 'supplier',
                customField: 'customFieldCompany',
                title: window.i18n.__('Champs personnalisés'),
                subtitle: window.i18n.__('Champs personnalisés'),
                subheading: window.i18n.__(' / Sociétés'),
            },
            {
                category: 'contact',
                customField: 'customFieldContact',
                title: window.i18n.__('Champs personnalisés'),
                subtitle: window.i18n.__('Champs personnalisés'),
                subheading: window.i18n.__(' / Contacts'),
            },
        ],
        isNew: true,
        fields: [
            /************************* COMPANY *************************/
            {
                key: 'company_id',
                type: 'number',
                label: window.i18n.__('Identifiant société'),
                description: window.i18n.__(
                    'Récupéré depuis un export Sellsy (Utile uniquement en cas de mise à jour).',
                ),
                metadata: {
                    castingType: CASTING_TYPES.INTEGER,
                },
            },
            {
                key: 'company_type',
                type: 'string',
                label: window.i18n.__('Type société'),
                description: window.i18n.__('Type de société parmi les 3 existants.'),
                required: true,
            },
            {
                key: 'company_name',
                type: 'string',
                label: window.i18n.__('Nom société'),
                description: window.i18n.__('Nom de société affiché dans les documents.'),
            },
            {
                key: 'company_reference',
                type: 'string',
                label: window.i18n.__('Référence'),
                description: window.i18n.__(
                    'Référence de la société affichée sur la fiche société.',
                ),
            },
            {
                key: 'company_legal_france_company_type',
                type: 'string',
                label: window.i18n.__('Forme juridique'),
                description: window.i18n.__('Statut juridique de la société (SA, SARL, EURL, …).'),
            },
            {
                key: 'company_price_category',
                type: 'string',
                label: window.i18n.__('Catégorie tarifaire'),
                description: window.i18n.__('Nom de la catégorie tarifaire de société.'),
            },
            {
                key: 'company_email',
                type: 'string',
                label: window.i18n.__('Email'),
                description: window.i18n.__('Adresse email de la société.'),
            },
            {
                key: 'company_phone_number',
                type: 'string',
                label: window.i18n.__('Téléphone'),
                description: window.i18n.__('Numéro de téléphone fixe de la société.'),
                metadata: {
                    castingType: CASTING_TYPES.PHONE_NUMBER,
                },
            },
            {
                key: 'company_mobile_number',
                type: 'string',
                label: window.i18n.__('Mobile'),
                description: window.i18n.__('Numéro de téléphone mobile de la société.'),
                metadata: {
                    castingType: CASTING_TYPES.PHONE_NUMBER,
                },
            },
            {
                key: 'company_fax_number',
                type: 'string',
                label: window.i18n.__('Fax'),
                description: window.i18n.__('Numéro de fax de la société.'),
                metadata: {
                    castingType: CASTING_TYPES.PHONE_NUMBER,
                },
            },
            {
                key: 'company_website',
                type: 'string',
                label: window.i18n.__('Site internet'),
                description: window.i18n.__('URL du site internet de la société.'),
            },
            {
                key: 'company_legal_france_vat',
                type: 'string',
                label: window.i18n.__('TVA'),
                description: window.i18n.__('N° de TVA intracommunautaire.'),
            },
            {
                key: 'company_legal_france_ape_naf_code',
                type: 'string',
                label: window.i18n.__('NAF'),
                description: window.i18n.__('Code NAF (APE).'),
            },
            {
                key: 'company_capital',
                type: 'number',
                label: window.i18n.__('Capital social'),
                description: window.i18n.__('Montant de l’apport à la création de la société.'),
            },
            {
                key: 'company_legal_france_rcs_immatriculation',
                type: 'string',
                label: window.i18n.__('RCS'),
                description: window.i18n.__('Numéro du Registre du Commerce et des Sociétés.'),
            },
            {
                key: 'company_legal_france_siret',
                type: 'string',
                label: window.i18n.__('SIRET'),
                description: window.i18n.__(
                    'Numéro du Système d’Identification du Répertoire des ETablissements.',
                ),
            },
            {
                key: 'company_legal_france_siren',
                type: 'string',
                label: window.i18n.__('SIREN'),
                description: window.i18n.__(
                    'Numéro du Système d’Identification du Répertoire des ENtreprises.',
                ),
            },
            {
                key: 'company_note',
                type: 'string',
                label: window.i18n.__('Note'),
                description: window.i18n.__(
                    'Contenu affiché dans le champ note de la fiche société.',
                ),
            },
            {
                key: 'company_smart_tags',
                type: 'string',
                label: window.i18n.__('Smart-tags'),
                description: window.i18n.__('Liste de smart-tags.'),
                metadata: {
                    castingType: CASTING_TYPES.NONE,
                },
            },
            {
                key: 'company_owner',
                type: 'string',
                label: window.i18n.__('Propriétaire'),
                description: window.i18n.__('Nom complet du propriétaire de la société.'),
            },
            {
                key: 'company_accounting_code',
                type: 'string',
                label: window.i18n.__('Compte tiers'),
                description: window.i18n.__('Code comptable à associer à ce tiers.'),
            },
            {
                key: 'company_auxiliary_code',
                type: 'string',
                label: window.i18n.__('Compte auxiliaire'),
                description: window.i18n.__('Code comptable auxiliaire à associer à ce tiers.'),
            },
            {
                key: 'company_marketing_campaigns_email',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes email'),
                description: window.i18n.__(
                    'Détermine si la société est inscrite aux campagnes email.',
                ),
            },
            {
                key: 'company_marketing_campaigns_sms',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes SMS'),
                description: window.i18n.__(
                    'Détermine si la société est inscrite aux campagnes SMS.',
                ),
            },
            {
                key: 'company_marketing_campaigns_phone',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes téléphonique'),
                description: window.i18n.__(
                    'Détermine si la société est inscrite aux campagnes téléphoniques.',
                ),
            },
            {
                key: 'company_marketing_campaigns_postal_mail',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes courrier'),
                description: window.i18n.__(
                    'Détermine si la société est inscrite aux campagnes courrier.',
                ),
            },
            {
                key: 'company_marketing_campaigns_custom',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes marketing personnalisé'),
                description: window.i18n.__(
                    'Détermine si la société est inscrite aux campagnes marketing personnalisé.',
                ),
            },
            {
                key: 'company_is_archived',
                type: 'boolean',
                label: window.i18n.__('Archivée'),
                description: window.i18n.__('Archiver ou non la société.'),
            },
            /************************* ADDRESS *************************/
            {
                key: 'address_id',
                type: 'number',
                label: window.i18n.__('Identifiant adresse'),
                description: window.i18n.__(
                    'Récupéré depuis un export Sellsy (Utile uniquement en cas de mise à jour).',
                ),
                metadata: {
                    castingType: CASTING_TYPES.INTEGER,
                },
            },
            {
                key: 'address_name',
                type: 'string',
                label: window.i18n.__('Nom adresse'),
                description: window.i18n.__('Nom à associer à l’adresse.'),
            },
            {
                key: 'address_address_line_1',
                type: 'string',
                label: window.i18n.__('Adresse partie 1'),
                description: window.i18n.__('Première partie de l’adresse.'),
            },
            {
                key: 'address_address_line_2',
                type: 'string',
                label: window.i18n.__('Adresse partie 2'),
                description: window.i18n.__('Deuxième partie de l’adresse.'),
            },
            {
                key: 'address_address_line_3',
                type: 'string',
                label: window.i18n.__('Adresse partie 3'),
                description: window.i18n.__('Troisième partie de l’adresse.'),
            },
            {
                key: 'address_address_line_4',
                type: 'string',
                label: window.i18n.__('Adresse partie 4'),
                description: window.i18n.__('Quatrième partie de l’adresse.'),
            },
            {
                key: 'address_postal_code',
                type: 'string',
                label: window.i18n.__('Code postal'),
                description: window.i18n.__('Code postal correspondant à l’adresse.'),
            },
            {
                key: 'address_city',
                type: 'string',
                label: window.i18n.__('Ville'),
                description: window.i18n.__('Ville correspondant à l’adresse.'),
            },
            {
                key: 'address_state',
                type: 'string',
                label: window.i18n.__('État / Province'),
                description: window.i18n.__('Utile uniquement pour des adresses non françaises.'),
            },
            {
                key: 'address_country_code',
                type: 'string',
                label: window.i18n.__('Code pays'),
                description: window.i18n.__('Code ISO du pays.'),
            },
            /************************* CONTACT *************************/
            {
                key: 'contact_id',
                type: 'number',
                label: window.i18n.__('Identifiant contact'),
                description: window.i18n.__(
                    'Récupéré depuis un export Sellsy (Utile uniquement en cas de mise à jour).',
                ),
                metadata: {
                    castingType: CASTING_TYPES.INTEGER,
                },
            },
            {
                key: 'contact_civility',
                type: 'string',
                label: window.i18n.__('Civilité contact'),
                description: window.i18n.__(
                    'Civilité affichée sur les documents envoyés au contact',
                ),
            },
            {
                key: 'contact_type_main',
                type: 'boolean',
                label: window.i18n.__('Type contact principal'),
                description: window.i18n.__(
                    'Détermine si le contact est de type “contact principal”.',
                ),
            },
            {
                key: 'contact_type_invoicing',
                type: 'boolean',
                label: window.i18n.__('Type contact de facturation'),
                description: window.i18n.__(
                    'Détermine si le contact est de type “contact de facturation”.',
                ),
            },
            {
                key: 'contact_type_dunning',
                type: 'boolean',
                label: window.i18n.__('Type contact de relance'),
                description: window.i18n.__(
                    'Détermine si le contact est de type “contact de relance”.',
                ),
            },
            {
                key: 'contact_last_name',
                type: 'string',
                label: window.i18n.__('Nom contact'),
                description: window.i18n.__('Nom affiché dans les documents envoyés au contact.'),
            },
            {
                key: 'contact_first_name',
                type: 'string',
                label: window.i18n.__('Prénom contact'),
                description: window.i18n.__('Prénom affiché sur les documents envoyés au contact.'),
            },
            {
                key: 'contact_email',
                type: 'string',
                label: window.i18n.__('Email contact'),
                description: window.i18n.__('Adresse email utilisée pour les emails générés.'),
            },
            {
                key: 'contact_phone_number',
                type: 'string',
                label: window.i18n.__('Téléphone contact'),
                description: window.i18n.__('Numéro de téléphone fixe du contact.'),
                metadata: {
                    castingType: CASTING_TYPES.PHONE_NUMBER,
                },
            },
            {
                key: 'contact_mobile_number',
                type: 'string',
                label: window.i18n.__('Mobile contact'),
                description: window.i18n.__('Numéro de téléphone mobile du contact.'),
                metadata: {
                    castingType: CASTING_TYPES.PHONE_NUMBER,
                },
            },
            {
                key: 'contact_fax_number',
                type: 'string',
                label: window.i18n.__('Fax contact'),
                description: window.i18n.__('Numéro de fax du contact.'),
                metadata: {
                    castingType: CASTING_TYPES.PHONE_NUMBER,
                },
            },
            {
                key: 'contact_website',
                type: 'string',
                label: window.i18n.__('Site internet contact'),
                description: window.i18n.__('URL du site internet du contact.'),
            },
            {
                key: 'contact_position',
                type: 'string',
                label: window.i18n.__('Fonction contact'),
                description: window.i18n.__('Fonction du contact.'),
            },
            {
                key: 'contact_smart_tags',
                type: 'string',
                label: window.i18n.__('Smart-tags contact'),
                description: window.i18n.__('Liste de smart-tags.'),
                metadata: {
                    castingType: CASTING_TYPES.NONE,
                },
            },
            {
                key: 'contact_note',
                type: 'string',
                label: window.i18n.__('Note contact'),
                description: window.i18n.__(
                    'Contenu affiché dans le champ note de la fiche contact.',
                ),
            },
            {
                key: 'contact_marketing_campaigns_email',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes email contact'),
                description: window.i18n.__(
                    'Détermine si le contact est inscrit aux campagnes email.',
                ),
            },
            {
                key: 'contact_marketing_campaigns_sms',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes SMS contact'),
                description: window.i18n.__(
                    'Détermine si le contact est inscrit aux campagnes SMS.',
                ),
            },
            {
                key: 'contact_marketing_campaigns_phone',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes téléphonique contact'),
                description: window.i18n.__(
                    'Détermine si le contact est inscrit aux campagnes téléphoniques.',
                ),
            },
            {
                key: 'contact_marketing_campaigns_postal_mail',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes courrier contact'),
                description: window.i18n.__(
                    'Détermine si le contact est inscrit aux campagnes courrier.',
                ),
            },
            {
                key: 'contact_marketing_campaigns_custom',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes marketing personnalisé contact'),
                description: window.i18n.__(
                    'Détermine si le contact est inscrit aux campagnes marketing personnalisées.',
                ),
            },
            {
                key: 'contact_is_archived',
                type: 'boolean',
                label: window.i18n.__('Contact archivé'),
                description: window.i18n.__('Archiver ou non le contact.'),
            },
        ],
        customFieldCategoryDisplayOrder: [
            'company_contact',
            'customFieldCompany',
            'customFieldContact',
        ],
    },
    {
        type: 'individual',
        id: 3,
        title: window.i18n.__('Particuliers'),
        description: window.i18n.__(
            'Les particuliers correspondent à des personnes physiques clients, prospects ou fournisseurs, pour lesquelles vous détenez des informations individuelles.',
        ),
        icon: 'obj-slsy-individual',
        object: 'individual',
        dataBot: 'import-card-individual',
        isNew: false,
    },
    {
        type: 'contact',
        id: 4,
        title: window.i18n.__('Contacts seuls'),
        description: window.i18n.__(
            'Les contacts seuls correspondent à des personnes physiques interagissant avec votre entreprise et qui ne sont pas liés à une société.',
        ),
        comparisonCriteriaDescription: window.i18n.__(
            'Cette section vous permet de déterminer les critères sur lesquels nous allons déterminer si un contact existe déjà dans vos données Sellsy.',
        ),
        icon: 'obj-slsy-contact',
        object: 'contact',
        optionsDictionary: 'importContactOptionsDictionary',
        displaySubTypeOrder: ['contact'],
        dataBot: 'import-card-contact',
        customFieldsRelated: [
            {
                category: 'contact',
                customField: 'customFieldContact',
                title: window.i18n.__('Champs personnalisés'),
                subtitle: window.i18n.__('Champs personnalisés'),
                subheading: window.i18n.__(' / Contacts'),
            },
        ],
        isNew: true,
        fields: [
            {
                key: 'contact_id',
                type: 'number',
                label: window.i18n.__('Identifiant contact'),
                description: window.i18n.__(
                    'Récupéré uniquement depuis un export Sellsy. Utile uniquement en cas de mise à jour',
                ),
                metadata: { castingType: CASTING_TYPES.INTEGER },
            },
            {
                key: 'contact_civility',
                type: 'string',
                label: window.i18n.__('Civilité contact'),
                description: window.i18n.__('Civilité du contact'),
            },
            {
                key: 'contact_last_name',
                type: 'string',
                label: window.i18n.__('Nom contact'),
                description: window.i18n.__('Nom de famille du contact'),
            },
            {
                key: 'contact_first_name',
                type: 'string',
                label: window.i18n.__('Prénom contact'),
                description: window.i18n.__('Prénom du contact'),
            },
            {
                key: 'contact_email',
                type: 'string',
                label: window.i18n.__('Email contact'),
                description: window.i18n.__('Adresse email du contact'),
            },
            {
                key: 'contact_phone_number',
                type: 'string',
                label: window.i18n.__('Téléphone contact'),
                description: window.i18n.__('Numéro de téléphone fixe du contact'),
                metadata: {
                    castingType: CASTING_TYPES.PHONE_NUMBER,
                },
            },
            {
                key: 'contact_mobile_number',
                type: 'string',
                label: window.i18n.__('Mobile contact'),
                description: window.i18n.__('Numéro de téléphone mobile du contact'),
                metadata: {
                    castingType: CASTING_TYPES.PHONE_NUMBER,
                },
            },
            {
                key: 'contact_fax_number',
                type: 'string',
                label: window.i18n.__('Fax contact'),
                description: window.i18n.__('Numéro de fax du contact'),
                metadata: {
                    castingType: CASTING_TYPES.PHONE_NUMBER,
                },
            },
            {
                key: 'contact_website',
                type: 'string',
                label: window.i18n.__('Site internet contact'),
                description: window.i18n.__('URL du site internet du contact'),
            },
            {
                key: 'contact_position',
                type: 'string',
                label: window.i18n.__('Fonction contact'),
                description: window.i18n.__('Fonction du contact'),
            },
            {
                key: 'contact_smart_tags',
                type: 'string',
                label: window.i18n.__('Smart-tags'),
                description: window.i18n.__('Liste de smart-tags'),
                metadata: {
                    castingType: CASTING_TYPES.NONE,
                },
            },
            {
                key: 'contact_owner',
                type: 'string',
                label: window.i18n.__('Propriétaire'),
                description: window.i18n.__('Propriétaire du société'),
            },
            {
                key: 'contact_note',
                type: 'string',
                label: window.i18n.__('Note contact'),
                description: window.i18n.__(
                    'Contenu affiché dans le champ note de la fiche contact',
                ),
            },
            {
                key: 'contact_marketing_campaigns_email',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes email contact'),
                description: window.i18n.__(
                    'Détermine si le contact est inscrit aux campagnes email',
                ),
            },
            {
                key: 'contact_marketing_campaigns_sms',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes SMS contact'),
                description: window.i18n.__(
                    'Détermine si le contact est inscrit aux campagnes SMS',
                ),
            },
            {
                key: 'contact_marketing_campaigns_phone',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes téléphonique contact'),
                description: window.i18n.__(
                    'Détermine si le contact est inscrit aux campagnes téléphoniques',
                ),
            },
            {
                key: 'contact_marketing_campaigns_postal_mail',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes courrier contact'),
                description: window.i18n.__(
                    'Détermine si le contact est inscrit aux campagnes courrier',
                ),
            },
            {
                key: 'contact_marketing_campaigns_custom',
                type: 'boolean',
                label: window.i18n.__('Inscrit campagnes marketing personnalisé contact'),
                description: window.i18n.__(
                    'Détermine si le contact est inscrit aux campagnes marketing personnalisées',
                ),
            },
            {
                key: 'contact_is_archived',
                type: 'boolean',
                label: window.i18n.__('Archivé'),
                description: window.i18n.__('Archiver ou non le contact'),
            },
        ],
    },
    {
        type: 'comment',
        id: 5,
        title: window.i18n.__('Commentaires'),
        description: window.i18n.__(
            'Les commentaires correspondent aux remarques ou observations rédigées au fur et à mesure de la relation avec vos clients, prospects ou fournisseurs.',
        ),
        icon: 'obj-slsy-comment',
        object: 'comment',
        dataBot: 'import-card-comment',
        isNew: false,
    },
    {
        type: 'service',
        id: 6,
        title: window.i18n.__('Services'),
        description: window.i18n.__(
            'Les services font partie de votre catalogue et correspondent aux prestations que vous proposez à la vente au sein de votre entreprise.',
        ),
        comparisonCriteriaDescription: window.i18n.__(
            'Cette section vous permet de déterminer le critère sur lequel nous allons déterminer si un service existe déjà dans vos données Sellsy.',
        ),
        icon: 'obj-slsy-product',
        object: 'product',
        dataBot: 'import-card-service',
        optionsDictionary: 'importServiceOptionsDictionary',
        displaySubTypeOrder: ['service'],
        customFieldsRelated: [
            {
                category: 'service',
                customField: 'customFieldService',
                title: window.i18n.__('Champs personnalisés service'),
                subtitle: window.i18n.__('Champs personnalisés'),
            },
        ],
        isNew: true,
        fields: [
            {
                key: 'id',
                type: 'number',
                label: window.i18n.__('Identifiant service'),
                description: window.i18n.__(
                    'Récupéré depuis un export Sellsy (Utile uniquement en cas de mise à jour).',
                ),
                metadata: { castingType: CASTING_TYPES.INTEGER },
            },
            {
                key: 'reference',
                type: 'string',
                label: window.i18n.__('Référence'),
                description: window.i18n.__(
                    'Référence ou code du service unique dans votre catalogue.',
                ),
            },
            {
                key: 'name',
                type: 'string',
                label: window.i18n.__('Nom commercial'),
                description: window.i18n.__('Nom du service affiché sur les documents.'),
            },
            {
                key: 'description',
                type: 'string',
                label: window.i18n.__('Description'),
                description: window.i18n.__('Description affichée sur les documents.'),
            },
            {
                key: 'unit',
                type: 'string',
                label: window.i18n.__('Unité'),
                description: window.i18n.__('Unité de quantification du service.'),
            },
            {
                key: 'standard_quantity',
                type: 'number',
                label: window.i18n.__('Quantité usuelle'),
                description: window.i18n.__('Quantité usuelle du service.'),
            },
            {
                key: 'category',
                type: 'string',
                label: window.i18n.__('Catégorie'),
                description: window.i18n.__(
                    'Catégorie du service. Visibles dans Catalogue -> Catégories.',
                ),
            },
            {
                key: 'smart_tags',
                type: 'string',
                label: window.i18n.__('Smart-tags'),
                description: window.i18n.__('Liste de smart-tags. À séparer par une virgule.'),
            },
            {
                key: 'owner',
                type: 'string',
                label: window.i18n.__('Propriétaire'),
                description: window.i18n.__('Nom complet du propriétaire du service importé.'),
            },
            {
                key: 'is_timetracking',
                type: 'boolean',
                label: window.i18n.__('Le service est utilisable dans le timetracking'),
                description: window.i18n.__(
                    'Utilisable sur le timetracking. Valeurs possibles: Y/N',
                ),
            },
            {
                key: 'reference_price',
                type: 'number',
                label: window.i18n.__('Prix de référence HT'),
                description: window.i18n.__('Prix de référence hors taxe du service.'),
            },
            {
                key: 'tax_rate',
                type: 'number',
                label: window.i18n.__('Taxe'),
                description: window.i18n.__('Taux de taxe associé au service.'),
            },
            {
                key: 'purchase_price',
                type: 'number',
                label: window.i18n.__('Prix achat HT'),
                description: window.i18n.__("Prix d'achat hors taxe du service."),
            },
            {
                key: 'accounting_code',
                type: 'string',
                label: window.i18n.__('Code comptable vente'),
                description: window.i18n.__('Code comptable de vente à associer au service.'),
            },
            {
                key: 'accounting_purchase_code',
                type: 'string',
                label: window.i18n.__('Code comptable achat'),
                description: window.i18n.__("Code comptable d'achat à associer au service."),
            },
            {
                key: 'is_archived',
                type: 'boolean',
                label: window.i18n.__('Archivé'),
                description: window.i18n.__('Archiver ou non le service.'),
            },
        ],
    },
    {
        type: 'stock',
        id: 7,
        title: window.i18n.__('Inventaire'),
        description: window.i18n.__(
            'L’inventaire correspond à l’état actuel des quantités en stock de vos services sérialisés ou non sérialisés au sein de vos entrepôts.',
        ),
        icon: 'obj-slsy-stock',
        object: 'stock',
        dataBot: 'import-card-inventory',
        isNew: false,
    },
    {
        type: 'rate_category',
        id: 8,
        title: window.i18n.__('Tarifs'),
        description: window.i18n.__(
            'Les tarifs correspondent à vos différentes catégories tarifaires permettant de définir plusieurs prix de vente dans votre catalogue.',
        ),
        icon: 'obj-slsy-payment',
        dataBot: 'import-card-rate',
        isNew: false,
    },
    {
        type: 'opportunity',
        id: 9,
        title: window.i18n.__('Opportunités'),
        description: window.i18n.__(
            'Les opportunités correspondent aux affaires commerciales de vos prospects ou clients dont vous pouvez assurer le suivi par étape grâce aux pipelines.',
        ),
        icon: 'obj-slsy-opportunity',
        object: 'opportunity',
        dataBot: 'import-card-opportunity',
        isNew: false,
    },
    {
        type: 'product-variation',
        id: 10,
        title: window.i18n.__('Déclinaisons'),
        mainImportTitle: window.i18n.__('Produits'),
        // segmented title has the precedence over the regular title at some places when rendered
        description: window.i18n.__(
            'Les déclinaisons correspondent à différentes version d’un même produit que vous proposez à la vente au sein de votre entreprise.',
        ),
        comparisonCriteriaDescription: window.i18n.__(
            'Cette section vous permet de déterminer le critère sur lequel nous allons déterminer si une déclinaison produit existe déjà dans vos données Sellsy.',
        ),
        icon: 'obj-slsy-product',
        object: 'product',
        optionsDictionary: 'importProductVariationOptionsDictionary',
        displaySubTypeOrder: [
            // camelCase as per API spec
            'productVariation',
        ],
        dataBot: 'import-card-product-variation',
        isNew: true,
        fields: [
            {
                key: 'product_id',
                type: 'number',
                label: window.i18n.__('Identifiant produit'),
                description: window.i18n.__(
                    'Récupéré depuis un export Sellsy (Utile uniquement en cas de mise à jour).',
                ),
                metadata: {
                    castingType: CASTING_TYPES.INTEGER,
                },
            },
            {
                key: 'variation_id',
                type: 'number',
                label: window.i18n.__('Identifiant déclinaison'),
                description: window.i18n.__(
                    'Récupéré depuis un export de déclinaisons produit Sellsy (Utile uniquement en cas de mise à jour).',
                ),
                metadata: {
                    castingType: CASTING_TYPES.INTEGER,
                },
            },
            {
                key: 'product_reference',
                type: 'string',
                label: window.i18n.__('Référence produit'),
                description: window.i18n.__(
                    'Référence ou code du produit auquel sera ajoutée la déclinaison.',
                ),
            },
            {
                key: 'variation_reference',
                type: 'string',
                label: window.i18n.__('Référence déclinaison'),
                description: window.i18n.__('Référence de la déclinaison produit à ajouter.'),
            },
            {
                key: 'trade_name',
                type: 'string',
                label: window.i18n.__('Nom commercial'),
                description: window.i18n.__('Nom commercial de la déclinaison produit.'),
            },
            {
                key: 'variation_code_1',
                type: 'string',
                label: window.i18n.__('Code déclinaison 1'),
                description: window.i18n.__('Le code du premier critère de déclinaison.'),
            },
            {
                key: 'variation_code_value_1',
                type: 'string',
                label: window.i18n.__('Code valeur déclinaison 1'),
                description: window.i18n.__(
                    'Le code d’une valeur du premier critère de déclinaison.',
                ),
            },
            {
                key: 'variation_code_2',
                type: 'string',
                label: window.i18n.__('Code déclinaison 2'),
                description: window.i18n.__('Le code du deuxième critère de déclinaison.'),
            },
            {
                key: 'variation_code_value_2',
                type: 'string',
                label: window.i18n.__('Code valeur déclinaison 2'),
                description: window.i18n.__(
                    'Le code d’une valeur du deuxième critère de déclinaison.',
                ),
            },
            {
                key: 'variation_code_3',
                type: 'string',
                label: window.i18n.__('Code déclinaison 3'),
                description: window.i18n.__('Le code du troisième critère de déclinaison.'),
            },
            {
                key: 'variation_code_value_3',
                type: 'string',
                label: window.i18n.__('Code valeur déclinaison 3'),
                description: window.i18n.__(
                    'Le code d’une valeur du troisième critère de déclinaison.',
                ),
            },
            {
                key: 'sales_price_excl_tax',
                type: 'number',
                label: window.i18n.__('Prix vente HT'),
                description: window.i18n.__('Prix de vente hors taxe de la déclinaison.'),
            },
            {
                key: 'purchase_price_excl_tax',
                type: 'number',
                label: window.i18n.__('Prix achat HT'),
                description: window.i18n.__("Prix d'achat hors taxe de la déclinaison."),
            },
            {
                key: 'description',
                type: 'string',
                label: window.i18n.__('Description'),
                description: window.i18n.__('Description de la déclinaison.'),
            },
        ],
    },
    {
        type: 'service-price',
        id: 11,
        title: window.i18n.__('Catégorie tarifaire'),
        mainImportTitle: window.i18n.__('Services'),
        description: window.i18n.__(
            'Les catégories tarifaires permettent de définir plusieurs prix de vente de service dans votre catalogue.',
        ),
        comparisonCriteriaDescription: window.i18n.__(
            'Cette section vous permet de déterminer le critère sur lequel nous allons déterminer si un service existe déjà dans vos données Sellsy.',
        ),
        icon: 'obj-slsy-product',
        object: 'product',
        optionsDictionary: 'importServicePriceOptionsDictionary',
        displaySubTypeOrder: [
            // camelCase as per API spec
            'servicePrice',
        ],
        dataBot: 'import-card-service-price',
        isNew: true,
        fields: [
            {
                key: 'id',
                type: 'number',
                label: window.i18n.__('Identifiant service'),
                description: window.i18n.__('Récupéré depuis un export services Sellsy.'),
                metadata: {
                    castingType: CASTING_TYPES.INTEGER,
                },
            },
            {
                key: 'reference',
                type: 'string',
                label: window.i18n.__('Référence service'),
                description: window.i18n.__(
                    'Référence ou code du service unique auquel sera défini le prix de vente.',
                ),
            },
        ],
    },
    {
        type: 'product-price',
        id: 12,
        title: window.i18n.__('Catégorie tarifaire'),
        mainImportTitle: window.i18n.__('Produits'),
        description: window.i18n.__(
            'Les catégories tarifaires permettent de définir plusieurs prix de vente de produit dans votre catalogue.',
        ),
        comparisonCriteriaDescription: window.i18n.__(
            'Cette section vous permet de déterminer le critère sur lequel nous allons déterminer si un produit existe déjà dans vos données Sellsy.',
        ),
        icon: 'obj-slsy-product',
        object: 'product',
        optionsDictionary: 'importProductPriceOptionsDictionary',
        displaySubTypeOrder: [
            // camelCase as per API spec
            'productPrice',
        ],
        dataBot: 'import-card-product-price',
        isNew: true,
        fields: [
            {
                key: 'id',
                type: 'number',
                label: window.i18n.__('Identifiant produit'),
                description: window.i18n.__('Récupéré depuis un export produits Sellsy.'),
                metadata: {
                    castingType: CASTING_TYPES.INTEGER,
                },
            },
            {
                key: 'reference',
                type: 'string',
                label: window.i18n.__('Référence produit'),
                description: window.i18n.__(
                    'Référence ou code du produit unique sur lequel la catégorie tarifaire sera mise à jour.',
                ),
            },
            {
                key: 'variation_id',
                type: 'number',
                label: window.i18n.__('Identifiant déclinaison'),
                description: window.i18n.__(
                    'Récupéré depuis un export de déclinaisons produit Sellsy.',
                ),
                metadata: {
                    castingType: CASTING_TYPES.INTEGER,
                },
            },
            {
                key: 'variation_reference',
                type: 'string',
                label: window.i18n.__('Référence déclinaison'),
                description: window.i18n.__(
                    'Référence ou code de la déclinaison produit unique sur lequel la catégorie tarifaire sera mise à jour.',
                ),
            },
        ],
    },
];
